import React, { useEffect } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../src/styles/theme';

/**
 * Recipe Suggestions Screen - DEPRECATED
 *
 * This screen is being replaced by "The Weekly" magazine-style meal planner.
 * Redirects to home page which will show the new weekly view.
 */
const RecipeSuggestionsScreen: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();

  useEffect(() => {
    // Redirect to home after a brief moment
    const timer = setTimeout(() => {
      router.replace('/(app)');
    }, 1500);
    return () => clearTimeout(timer);
  }, [router]);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('recipeSuggestions.title')}</Text>
      <Text style={styles.subtitle}>{t('recipeSuggestions.moved')}</Text>
      <ActivityIndicator size="large" color={Colors.primary} style={styles.spinner} />
      <Text style={styles.redirectText}>{t('common.redirecting')}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.background,
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: Colors.text,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: 24,
  },
  spinner: {
    marginBottom: 16,
  },
  redirectText: {
    fontSize: 14,
    color: '#999',
  },
});

export default RecipeSuggestionsScreen;
